var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#FFE556"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 47.5C46.5 45.4067 46.5 44.36 46.2416 43.5083C45.6599 41.5907 44.1593 40.0901 42.2417 39.5084C41.39 39.25 40.3433 39.25 38.25 39.25H30.75C28.6567 39.25 27.61 39.25 26.7583 39.5084C24.8407 40.0901 23.3401 41.5907 22.7584 43.5083C22.5 44.36 22.5 45.4067 22.5 47.5M41.25 27.25C41.25 30.9779 38.2279 34 34.5 34C30.7721 34 27.75 30.9779 27.75 27.25C27.75 23.5221 30.7721 20.5 34.5 20.5C38.2279 20.5 41.25 23.5221 41.25 27.25Z",
    stroke: "#303539",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personal_icon.ca48ac48c770ede98e7360b77588f3f1.svg";
export { ForwardRef as ReactComponent };